import Notification from '../components/controls/Notification';

const ErrorHandler = (message, history) => {
  if (message === 'Session Expired') {
    localStorage.clear();
    history.push('/login');
  } else {
    Notification(message, 'error');
  }
};

export default ErrorHandler;
